import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {InputFile} from 'components/ui-kit/FileInput';
import {CreatableSelect, SelectOption} from 'components/ui-kit/Select';
import {codesFileChanged, filtersChanged, tableState$} from 'models/products/grid/table';
import {ProductsGridAccessors} from 'types';

import {FieldWithFile} from './styled';

function normalizeSelectValue(
    value: Array<SelectOption<string>> | null,
): Array<SelectOption<string>> {
    return Array.isArray(value) ? value : [];
}

function readFile(file: File | null): Promise<string[] | undefined> {
    return new Promise((resolve) => {
        if (!file) {
            resolve(undefined);
            return;
        }

        const reader = new FileReader();
        reader.readAsText(file);
        reader.addEventListener('load', () => {
            const text = reader.result as string;

            const lines = text.match(/[^\r\n]+/g);
            resolve(lines || undefined);
        });
    });
}

export const MarkingCodeFilter = () => {
    const {t} = useTranslation();

    const {filters, codesFile} = useStore(tableState$);
    const filterValue = filters[ProductsGridAccessors.codesFilter] ?? [];

    const removeSpaces = (value: SelectOption<string> | null) => {
        if (!value) return null;
        if (!value.label || !value.value) return null;
        return {
            label: value.label
                ?.toString()
                .trim()
                .replace(/\s/g, ''),
            value: value.value
                ?.toString()
                .trim()
                .replace(/\s/g, ''),
        };
    };

    const setFilterValue = (value: SelectOption<string> | null) => {
        const arrFromValue: Array<SelectOption<string>> | null = removeSpaces(value)
            ? [removeSpaces(value) as SelectOption<string>]
            : null;
        filtersChanged([
            {id: ProductsGridAccessors.codesFilter, value: normalizeSelectValue(arrFromValue)},
        ]);
    };

    const handleChangeFile = (evt: any): void => {
        const file = evt?.target?.files?.[0];
        readFile(file).then((result) => {
            codesFileChanged(file);
            filtersChanged([{id: ProductsGridAccessors.codesFileFilter, value: result}]);
        });
    };

    return (
        <FieldWithFile>
            <div style={{minWidth: 350}}>
                <CreatableSelect
                    isClearable
                    noOptionsMessage={() => t('pages.products.grid.noOptions')} // введите номер
                    formatCreateLabel={(value: string) =>
                        `${t('pages.products.grid.add')} "${value}"`
                    } // Добавить
                    onChange={setFilterValue}
                    value={Array.isArray(filterValue) ? filterValue[0] : filterValue}
                    placeholder={t('pages.products.grid.noOptions')}
                />
            </div>
            {/*<InputFile*/}
            {/*    type="file"*/}
            {/*    label={t('components.form.uploadButton')}*/}
            {/*    initialValue={codesFile?.name}*/}
            {/*    style={{minWidth: 350}}*/}
            {/*    onChange={(evt) => handleChangeFile(evt)}*/}
            {/*    accept=".csv"*/}
            {/*/>*/}
        </FieldWithFile>
    );
};
